// Configuration Constants
// Kamando Bakery Website

import type { Config } from '@/types'

export const CONFIG: Config = {
  STORE: {
    name: '諫早パン工房Kamando',
    company: '株式会社S&K',
    address: '〒854-0062 長崎県諫早市小船越町９０６−７',
    phone: '0957-26-4613',
    instagram: '@breadshopkamando',
    instagramUrl: 'https://www.instagram.com/breadshopkamando',
    hours: {
      weekday: '月〜金: 8:00 - 17:00',
      weekend: '土日祝: 8:00 - 18:00',
      holiday: '不定休'
    },
    location: {
      lat: 32.84289086295414,
      lng: 130.03175782383255,
      zoom: 16
    }
  },

  SLIDESHOW: {
    autoPlayInterval: 3000,
    transitionDuration: 1000,
    images: [
      { src: '/assets/img/making_image_1.jpg', alt: 'パン作りの様子1' },
      { src: '/assets/img/making_image_2.jpg', alt: 'パン作りの様子2' },
      { src: '/assets/img/making_image_3.jpg', alt: 'パン作りの様子3' },
      { src: '/assets/img/making_image_4.jpg', alt: 'パン作りの様子4' }
    ]
  },

  PAGE_TOP: {
    showThreshold: 300,
    scrollBehavior: 'smooth'
  },

  ANIMATION: {
    scrollThreshold: 1.25,
    transitionDuration: '0.3s'
  }
} as const
